<script lang="ts">
    import { RECAPTCHA_TARGET_HTML_ID } from '../../../config';

    import type { GoogleRecaptchaConfig } from '../utils/types';
    export let googleRecaptchaConfig: GoogleRecaptchaConfig;
</script>

<div
    data-sitekey="{googleRecaptchaConfig.sitekey}"
    id="{RECAPTCHA_TARGET_HTML_ID}"
    data-size="invisible"
    data-hl="{googleRecaptchaConfig.locale}"
></div>
